import React from "react";
import UseScrollAnimation from "../Elements/ScrollAnimation";

function TermsConditions() {
  UseScrollAnimation(); // ✅ just call it

  const getHref = (type, value) => {
    switch (type) {
      case "email":
        return `mailto:${value}`;
      case "phone":
        return `tel:${value}`;
      case "map":
        return `https://www.google.com/maps?q=${encodeURIComponent(value)}`;
      default:
        return "#";
    }
  };

  const contactInfo = [
    {
      label: "Email:",
      value: "info@corneliuswoods.net",
      type: "email",
    },
    {
      label: "Call Us:",
      value: "+18886220033",
      display: "(888) 622-0033",
      type: "phone",
    },
    {
      label: "Address:",
      value: "19181 Zion Ave, Cornelius, NC 28031",
      type: "map",
    },
  ];
  return (
    <div className="LocalInformationParent">
      <div className="LocalInformationBox">
        <div className="LocalInformationBoxHeading">
          <span className="LocalInformationBoxHeadingWord animate-top">
            Terms & Conditions
          </span>
          <span className="LocalInformationBoxHeadingLine animate-top"></span>
        </div>
        <div className="LocalInformationBoxContentBox">
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              Last Updated: April 8, 2026
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              Welcome to the Cornelius Woods website. By using our website, you
              are agreeing to these Terms and Conditions. Please read them
              carefully.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              1. Acceptance of Terms
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              Your use of the Cornelius Woods website constitutes your agreement
              to all such terms, conditions, and notices. If you do not agree
              with these terms, please do not use our website.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              2. Modification of These Terms
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              We reserve the right to change the terms, conditions, and notices
              under which our website is offered. Your continued use of our
              website after any such changes constitutes your agreement to such
              changes.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              3. Copyright and Trademarks
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              All content, graphics, format, design, the user interface and
              other copyrighted material on the website are protected by
              copyright law and other intellectual property laws, and are owned
              by Cornelius Woods and/or its licensors (as the case may be). The
              materials from the website are only available for informational
              and non-commercial offline use, provided that: the materials are
              not modified in any way; all copyright and other proprietary
              notices and markings are retained and reproduced in their entirety
              on any copy made from any material on the website; and Cornelius
              Woods has, in its sole discretion, given its consent in writing to
              such use of the website's material.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              4. Personal and Non-Commercial Use
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              You may use our website for personal, non-commercial use only. You
              may not use this website to sell a product or service, or to
              increase traffic to your website for commercial reasons.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              5. No Unlawful or Prohibited Use
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              You may not use this website in any way that violates any
              applicable local, national, or international laws or regulations,
              or in any way that is unlawful or fraudulent.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              6. Indemnification
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              You agree to indemnify and hold Cornelius Woods, its officers,
              directors, shareholders, predecessors, successors in interest,
              employees, agents, subsidiaries and affiliates, harmless from any
              demands, loss, liability, claims or expenses (including attorneys’
              fees), made against Cornelius Woods by any third party due to or
              arising out of or in connection with your use of the website.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              7. Limitation of Liability
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              In no event shall Cornelius Woods be liable for any direct,
              indirect, punitive, incidental, special, consequential damages or
              any damages whatsoever including, without limitation, damages for
              loss of use, data or profits, arising out of or in any way
              connected with the use or performance of the website, with the
              delay or inability to use the website or related services, the
              provision of or failure to provide services, or for any
              information, software, products, services and related graphics
              obtained through the website.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              8. Governing Law
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              These terms and conditions are governed by and construed in
              accordance with the laws of North Carolina, and you irrevocably
              submit to the exclusive jurisdiction of the courts in that State
              or location.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              9. Contact Us
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              If you have any questions about these Terms and Conditions, please
              contact us at <br />
              <b>
                {contactInfo.map((item, index) => (
                  <span className="headerTopBoxRightBoxSections00" key={index}>
                    <span className="headerTopBoxRightBoxSectionLabel">
                      {item.label}
                    </span>

                    <a
                      href={getHref(item.type, item.value)}
                      className="headerTopBoxRightBoxSectionInput"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>{item.display || item.value} </span>
                    </a>
                  </span>
                ))}
              </b>
              .
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsConditions;
